import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import baseStyles from './styles/baseStyles';
const getStyles = createUseStyles({
    root: {
        ...baseStyles,
    }
});
const H5 = ({ children, className }) => {
    const styles = getStyles();
    return React.createElement("h5", { className: classNames(styles.root, className) }, children);
};
export default H5;
//# sourceMappingURL=H5.js.map